import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ChecklistSection from './components/ChecklistSection';
import { Summary, AIGuide, Tools, FinalCTA, Footer } from './components/Sections';
import { checklistData } from './data/checklistData';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] font-sans text-brand-black selection:bg-brand-cyan selection:text-brand-black">
      <Header />
      
      <main>
        <Hero />
        
        <div id="checklist-section" className="max-w-3xl mx-auto px-6 py-8 scroll-mt-20">
          {checklistData.map((data, index) => (
            <ChecklistSection 
              key={data.id} 
              data={data} 
              index={index + 1} 
              total={checklistData.length} 
            />
          ))}
        </div>

        <Summary />
        <AIGuide />
        <Tools />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}

export default App;